import { ReactNode } from "react";

export const Add = (): ReactNode => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M18 13H13V18C13 18.55 12.55 19 12 19C11.45 19 11 18.55 11 18V13H6C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11H11V6C11 5.45 11.45 5 12 5C12.55 5 13 5.45 13 6V11H18C18.55 11 19 11.45 19 12C19 12.55 18.55 13 18 13Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export const GoAway = (): ReactNode => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M18.3 5.70996C18.1132 5.5227 17.8595 5.41747 17.595 5.41747C17.3305 5.41747 17.0768 5.5227 16.89 5.70996L12 10.59L7.11002 5.69996C6.92318 5.5127 6.66953 5.40747 6.40502 5.40747C6.1405 5.40747 5.88685 5.5127 5.70002 5.69996C5.31002 6.08996 5.31002 6.71996 5.70002 7.10996L10.59 12L5.70002 16.89C5.31002 17.28 5.31002 17.91 5.70002 18.3C6.09002 18.69 6.72002 18.69 7.11002 18.3L12 13.41L16.89 18.3C17.28 18.69 17.91 18.69 18.3 18.3C18.69 17.91 18.69 17.28 18.3 16.89L13.41 12L18.3 7.10996C18.68 6.72996 18.68 6.08996 18.3 5.70996Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export const MenuIcon = (): ReactNode => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M18 10C18.55 10 19.0208 10.1958 19.4125 10.5875C19.8042 10.9792 20 11.45 20 12C20 12.55 19.8042 13.0208 19.4125 13.4125C19.0208 13.8042 18.55 14 18 14C17.45 14 16.9792 13.8042 16.5875 13.4125C16.1958 13.0208 16 12.55 16 12C16 11.45 16.1958 10.9792 16.5875 10.5875C16.9792 10.1958 17.45 10 18 10ZM12 10C12.55 10 13.0208 10.1958 13.4125 10.5875C13.8042 10.9792 14 11.45 14 12C14 12.55 13.8042 13.0208 13.4125 13.4125C13.0208 13.8042 12.55 14 12 14C11.45 14 10.9792 13.8042 10.5875 13.4125C10.1958 13.0208 10 12.55 10 12C10 11.45 10.1958 10.9792 10.5875 10.5875C10.9792 10.1958 11.45 10 12 10ZM6 10C6.55 10 7.02083 10.1958 7.4125 10.5875C7.80417 10.9792 8 11.45 8 12C8 12.55 7.80417 13.0208 7.4125 13.4125C7.02083 13.8042 6.55 14 6 14C5.45 14 4.97917 13.8042 4.5875 13.4125C4.19583 13.0208 4 12.55 4 12C4 11.45 4.19583 10.9792 4.5875 10.5875C4.97917 10.1958 5.45 10 6 10Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export const DragGrip = (): ReactNode => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M9 16C10.1 16 11 16.9 11 18C11 19.1 10.1 20 9 20C7.9 20 7 19.1 7 18C7 16.9 7.9 16 9 16ZM15 16C16.1 16 17 16.9 17 18C17 19.1 16.1 20 15 20C13.9 20 13 19.1 13 18C13 16.9 13.9 16 15 16ZM9 10C10.1 10 11 10.9 11 12C11 13.1 10.1 14 9 14C7.9 14 7 13.1 7 12C7 10.9 7.9 10 9 10ZM15 10C16.1 10 17 10.9 17 12C17 13.1 16.1 14 15 14C13.9 14 13 13.1 13 12C13 10.9 13.9 10 15 10ZM9 4C10.1 4 11 4.9 11 6C11 7.1 10.1 8 9 8C7.9 8 7 7.1 7 6C7 4.9 7.9 4 9 4ZM15 4C16.1 4 17 4.9 17 6C17 7.1 16.1 8 15 8C13.9 8 13 7.1 13 6C13 4.9 13.9 4 15 4Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export const ReverseSort = (): ReactNode => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M12.5919 9.84942C12.0639 9.84942 11.788 9.20091 12.172 8.82891L15.5197 5.49298C15.7596 5.26511 16.1312 5.26521 16.3712 5.49298L19.7199 8.82891C20.1037 9.20085 19.8397 9.84915 19.2999 9.84942L17.1515 9.84942L17.1515 17.0613C17.1513 17.7212 16.6112 18.2615 15.9513 18.2615C15.2915 18.2614 14.7513 17.7211 14.7511 17.0613L14.7511 9.84942L12.5919 9.84942ZM4.98256 15.6932C4.59865 15.3212 4.86268 14.6729 5.40248 14.6727L7.55092 14.6727L7.55091 7.46075C7.55106 6.80087 8.0912 6.26055 8.75111 6.26055C9.41086 6.26075 9.95019 6.80098 9.95033 7.46075L9.95033 14.6727L12.0988 14.6727C12.6388 14.6727 12.9024 15.3212 12.5304 15.6932L9.18275 19.0291C8.94284 19.257 8.57118 19.2568 8.33119 19.0291L4.98256 15.6932Z"
				fill="currentColor"
			/>
		</svg>
	);
};

export const Upload = (): ReactNode => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			fill="currentColor"
		>
			<g clipPath="url(#clip0_2072_1605)">
				<path d="M16.5 16.7222C16.9125 16.7222 17.25 17.0597 17.25 17.4722C17.25 17.8847 16.9125 18.2222 16.5 18.2222H7.5C7.0875 18.2222 6.75 17.8847 6.75 17.4722C6.75002 17.0597 7.08751 16.7222 7.5 16.7222H16.5ZM12.0039 5.77783C12.2022 5.77787 12.3921 5.85716 12.5322 5.99756L15.9746 9.43994C16.4471 9.91244 16.1099 10.7222 15.4424 10.7222H14.25V14.4722C14.25 14.8847 13.9125 15.2222 13.5 15.2222H10.5C10.0875 15.2222 9.75 14.8847 9.75 14.4722V10.7222H8.55762C7.89024 10.7222 7.56011 9.91248 8.03223 9.43994L11.4746 5.99756C11.6147 5.85712 11.8055 5.77783 12.0039 5.77783Z" />
			</g>
			<defs>
				<clipPath id="clip0_2072_1605">
					<rect width="24" height="24" rx="12" />
				</clipPath>
			</defs>
		</svg>
	);
};

export const Microphone = (): ReactNode => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			fill="currentColor"
		>
			<path d="M18.0797 12C18.5996 12 19.0001 12.4598 18.9303 12.9697C18.4703 15.9297 15.9596 18.2797 12.9996 18.7197V21C12.9996 21.55 12.5496 22 11.9996 22C11.4498 21.9997 10.9996 21.5498 10.9996 21V18.7197C8.02986 18.2695 5.52992 15.9296 5.06995 12.9697C5.00014 12.4598 5.40063 12 5.92053 12C6.33032 12.0002 6.68961 12.3002 6.74964 12.71C7.11961 15.3298 9.46981 17.0994 11.9996 17.0996C14.5296 17.0996 16.8796 15.3199 17.2496 12.71C17.3096 12.3001 17.6599 12.0002 18.0797 12ZM11.9996 3C13.6596 3 14.9996 4.34 14.9996 6L14.9899 12C14.9899 13.66 13.6596 15 11.9996 15C10.3399 14.9997 8.99964 13.6598 8.99964 12V6C8.99964 4.34016 10.3399 3.00025 11.9996 3Z" />
		</svg>
	);
};

export const ErrorIcon = (size: number): ReactNode => {
	return (
		<svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			fill="currentColor"
		>
			<path d="M12 2.0611C17.52 2.0611 22 6.5411 22 12.0611C22 17.5811 17.52 22.0611 12 22.0611C6.48 22.0611 2 17.5811 2 12.0611C2 6.5411 6.48 2.0611 12 2.0611ZM11 15.0611V17.0611H13V15.0611H11ZM12 7.0611C11.45 7.0611 11 7.5111 11 8.0611V12.0611C11 12.6111 11.45 13.0611 12 13.0611C12.55 13.0611 13 12.6111 13 12.0611V8.0611C13 7.5111 12.55 7.0611 12 7.0611Z" />
		</svg>
	);
};

export const EditIcon = (): ReactNode => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			fill="currentColor"
		>
			<path d="M3 17.25V21H6.75L17.81 9.94L14.06 6.19L3 17.25ZM20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C17.98 2.9 17.35 2.9 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04Z" />
		</svg>
	);
};

export const TrashIcon = (): ReactNode => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			fill="currentColor"
		>
			<path d="M6 19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7H6V19ZM8 9H16V19H8V9ZM15.5 4L14.5 3H9.5L8.5 4H5V6H19V4H15.5Z" />
		</svg>
	);
};

export const Download = (): ReactNode => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			fill="currentColor"
		>
			<path d="M12 16L7 11L8.4 9.55L11 12.15V4H13V12.15L15.6 9.55L17 11L12 16ZM6 20C5.45 20 4.97917 19.8042 4.5875 19.4125C4.19583 19.0208 4 18.55 4 18V15H6V18H18V15H20V18C20 18.55 19.8042 19.0208 19.4125 19.4125C19.0208 19.8042 18.55 20 18 20H6Z" />
		</svg>
	);
};

export const SpyGlass = (): ReactNode => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
		>
			<circle
				cx="10.5"
				cy="10.5"
				r="6.5"
				stroke="currentColor"
				strokeWidth="2"
			/>
			<line
				x1="15.5"
				y1="15.5"
				x2="21"
				y2="21"
				stroke="currentColor"
				strokeWidth="2"
				strokeLinecap="round"
			/>
		</svg>
	);
};

export const CoffeeCup = (): ReactNode => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<rect
				x="3"
				y="6"
				width="14"
				height="16"
				rx="2"
				stroke="currentColor"
				strokeWidth="1.5"
				fill="none"
			/>
			<path
				d="M17 10h3c1.5 0 3 1 3 3s-1.5 3-3 3h-3"
				stroke="currentColor"
				strokeWidth="1.5"
				fill="none"
			/>
		</svg>
	);
};

export const SuccessCheckmark = (): ReactNode => {
	return (
		<svg
			width="80"
			height="80"
			viewBox="0 0 28 28"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<circle
				cx="14"
				cy="14"
				r="13"
				stroke="#4ade80"
				strokeWidth="1.5"
				fill="none"
			/>
			<polyline
				points="7,14 12,19 21,8"
				stroke="#4ade80"
				strokeWidth="2"
				strokeLinecap="round"
				strokeLinejoin="round"
				fill="none"
			/>
		</svg>
	);
};

export const AiWrite = (): ReactNode => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			fill="none"
		>
			{/* Star/Sparkle - slightly smaller in upper left corner */}
			<path
				d="M7 2L8.5 6.5L13 8L8.5 9.5L7 14L5.5 9.5L1 8L5.5 6.5L7 2Z"
				fill="currentColor"
			/>
			{/* Pen/Pencil */}
			<path
				d="M6 17.25V21H9.75L20.81 9.94L17.06 6.19L6 17.25Z"
				fill="currentColor"
			/>
			<path
				d="M23.71 7.04C24.1 6.65 24.1 6.02 23.71 5.63L21.37 3.29C20.98 2.9 20.35 2.9 19.96 3.29L18.13 5.12L21.88 8.87L23.71 7.04Z"
				fill="currentColor"
			/>
		</svg>
	);
};
